(function() {
  'use strict';

  eclipseApp.directive('disableNgAnimate', ['$animate', function($animate) {
    return {
      restrict: 'A',
      link: function($scope, $element, $attrs) {
        // disable element's animation
        $animate.enabled(false, $element);
      }
    }
  }]);

})();
